import {
	AdditionalBookingOptionEntity,
	FreightPriceRangeEntity,
	MeasurementEntity,
	PassengerTypeEntity,
} from 'Models/Entities';
import axios from 'axios';
import { USER_FIXED_PRICING_API } from 'Constants';

export interface UserPricingFormData {
	passengerTypes: PassengerTypeEntity[];
	measurementTypes: MeasurementEntity[];
	additionalBookingOptions: AdditionalBookingOptionEntity[];
	freightPriceRanges: FreightPriceRangeEntity[];
}

export async function getAllUserPricingEntities(): Promise<UserPricingFormData> {
	const response = await axios.get(`${USER_FIXED_PRICING_API}/form-data`);

	const data = response.data as UserPricingFormData;
	return {
		passengerTypes: data.passengerTypes.map(y => new PassengerTypeEntity(y)),
		measurementTypes: data.measurementTypes.map(y => new MeasurementEntity(y)),
		additionalBookingOptions: data.additionalBookingOptions.map(y => new AdditionalBookingOptionEntity(y)),
		freightPriceRanges: data.freightPriceRanges.map(y => new FreightPriceRangeEntity(y)),
	};
}
